export default __webpack_public_path__ + "static/Group 614-fb86a105d3bb16935412ac6396bca4ff.png";